/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ComptabilityControllerDownloadReportMakingOrdersByMonths$Params {
  month: number;
  year: number;
  distributorId?: number;
  canceled: boolean;
}

export function comptabilityControllerDownloadReportMakingOrdersByMonths(http: HttpClient, rootUrl: string, params: ComptabilityControllerDownloadReportMakingOrdersByMonths$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, comptabilityControllerDownloadReportMakingOrdersByMonths.PATH, 'get');
  if (params) {
    rb.query('month', params.month, {});
    rb.query('year', params.year, {});
    rb.query('distributorId', params.distributorId, {});
    rb.query('canceled', params.canceled, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

comptabilityControllerDownloadReportMakingOrdersByMonths.PATH = '/api/comptability/download/report-making-orders-by-month';
